import MultiForm from '@admin/components/multiform'
import CanvaDesign from './canva_design'
import CanvaImport from './canva_import'
import PropTypes from 'prop-types'
import Truevail from './truevail'
import Strategy from './strategy'
import Details from './details'
import Library from './library'
import Design from './design'
import Type from './type'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Social Campaign)',
      action: '/api/admin/truevail/agency/social_campaigns',
      method: 'POST',
      props: this._getProps(),
      formatData: this._getData.bind(this),
      getSteps: this._getSteps,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getData(formdata) {
    return {
      title: formdata.title,
      type: formdata.type,
      social_campaign_id: formdata.social_campaign_id,
      variants: formdata.variants,
      language: formdata.language,
      perspective: formdata.perspective,
      design_url: formdata.design_url,
      status: formdata.status,
      folder_ids: formdata.folder_ids,
      tags: formdata.tags
    }
  }

  _getProps() {
    const { advisor } = this.props
    return { 
      advisor
    }
  }

  _getSteps(formdata) {
    const { strategy } = formdata
    return [
      { label: 't(Strategy)', component: Strategy },
      ...strategy === 'truevail' ? [
        { label: 't(Truevail)', component: Truevail }
      ] : strategy === 'canva' ? [
        { label: 't(Canva)', component: CanvaImport }
      ] : strategy === 'design' ? [
        { label: 't(Canva)', component: CanvaDesign }
      ] : [
        { label: 't(Type)', component: Type }
      ],
      ...strategy !== 'truevail' ? [
        { label: 't(Details)', component: Details },
        { label: 't(Design)', component: Design }
      ] : [],
      { label: 't(Library)', component: Library }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(social_campaigns) {
    this.context.router.push(`/truevail/agency/social_campaigns/${social_campaigns.id}`)
    this.context.modal.close()
  }

}

export default New
